import { render, staticRenderFns } from "./agregar_reembolsos.vue?vue&type=template&id=10c87362"
import script from "./agregar_reembolsos.vue?vue&type=script&lang=js"
export * from "./agregar_reembolsos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports